import React from 'react'
import Arrow from 'components/icons/Arrow'
import styles from './styles.module.css'
import withStyles from 'isomorphic-style-loader/withStyles'

function BackLink() {
  return (
    <a className={styles.link} href="#products">
      <Arrow />
      <span>К списку проектов</span>
    </a>
  )
}

export default withStyles(styles)(BackLink)
